module.exports = {
lines:[]
};



//////////////////
// WEBPACK FOOTER
// ./cfg/lines-config.js
// module id = 20
// module chunks = 0